<template>
  <div class="c-dmp g-container">
    <Spin v-if="!show" size="large" fix />
    <div class="module-content" ref="container">
      <moduler name="dmpadd" :title="title">
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">平台</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="platform" type="button" @on-change="changePlatform">
              <Radio :label="1" :disabled="editState">Andriod</Radio>
              <Radio :label="2" :disabled="editState">iOS</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">中间件游戏</span>
          </Col>
          <Col span="12">
            <!-- <auto-complete
              v-model="gameId"
              :data="gameData"
              :disabled="editState"
              placeholder="请选择游戏"
              style="width:280px"
              @on-select="handleGame" /> -->
            <el-select
              v-model="gameId"
              multiple
              collapse-tags
              size="small"
              filterable
              :disabled="editState"
              style="width: 280px"
              @change="handleGame"
              placeholder="请选择游戏"
            >
              <el-option v-for="item in gameData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">设备类型</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="dmpType" type="button">
              <Radio :label="1" :disabled="editState" v-if="platform === 1">OAID原值</Radio>
              <Radio :label="2" :disabled="editState" v-if="platform === 1">IMEI原值</Radio>
              <Radio :label="3" :disabled="editState" v-if="platform === 2">IDFA原值</Radio>
              <Radio :label="4" :disabled="editState">手机号加密值</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">用户类型</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="dataType" type="button" @on-change="changeDataType">
              <Radio label="active" :disabled="editState">激活用户</Radio>
              <Radio label="createRole" :disabled="editState">创角用户</Radio>
              <Radio label="lively" :disabled="editState">活跃用户</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="dataType === 'lively'">
          <Col span="3" class="col-item">
            <span class="item-field">时间范围</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="timeType" type="button">
              <Radio :label="1">近3日</Radio>
              <Radio :label="2">近5日</Radio>
              <Radio :label="3">近7日</Radio>
              <Radio :label="4">近14日</Radio>
              <Radio :label="5">近30日</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-else>
          <Col span="3" class="col-item">
            <span class="item-field">时间范围</span>
          </Col>
          <Col span="12">
            <DatePicker
              type="date"
              :value="beginTime"
              :options="{ disabledDate }"
              @on-change="changeBeginTime"
              placeholder="请选择起始日期"
              style="width: 124px"
            />
            <span style="padding: 0 10px">~</span>
            <!-- <Input
              value="至今"
              readonly
              disabled
              placeholder="请选择结束日期"
              style="width:80px" /> -->
            <DatePicker
              type="date"
              :value="endTime"
              :options="{ disabledDate }"
              @on-change="changeEndTime"
              placeholder="请选择结束日期"
              style="width: 124px"
            />
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">付费范围</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="paySwitch" type="button">
              <Radio :label="0">不限</Radio>
              <Radio :label="1">付费行为</Radio>
              <Radio :label="2">无付费</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-show="paySwitch === 1" style="align-items: flex-start">
          <Col span="3" class="col-item" style="line-height: 32px">
            <span class="item-field">&nbsp;</span>
          </Col>
          <Col span="12" class="col-flex">
            <condition v-model="payAction" :data="ruleData" :max="2" :verify="formErr" />
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field">媒体</span>
          </Col>
          <Col span="12">
            <RadioGroup v-model="mediaSwitch" type="button" @on-change="mediaIds = []">
              <Radio :label="0">不限</Radio>
              <Radio :label="1">按媒体</Radio>
            </RadioGroup>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" v-if="mediaSwitch">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">&nbsp;</span>
          </Col>
          <Col span="12">
            <el-select
              v-model="mediaIds"
              multiple
              collapse-tags
              filterable
              :popper-append-to-body="false"
              placeholder="请选择媒体"
              style="width: 220px"
              size="small"
            >
              <el-option v-for="label in mediaData" :key="label.id" :value="label.id" :label="label.name"></el-option>
            </el-select>
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">DMP包名称</span>
          </Col>
          <Col span="12">
            <input-len v-model="dmpName" placeholder="最大25个字符，1个中文等于2个字符" :max="25" width="392" @blur="changeSimpleName" />
          </Col>
        </Row>
        <Row class="row-item" :gutter="12">
          <Col span="3" class="col-item">
            <span class="item-field row-item-must">DMP包简称</span>
          </Col>
          <Col span="12">
            <input-len v-model="dmpSimpleName" placeholder="系统生成有误请手动修改，最大25个字符" :max="25" width="392" />
          </Col>
        </Row>
        <Row class="row-item" :gutter="12" style="align-items: flex-start">
          <Col span="3" class="col-item" style="line-height: 32px">
            <span class="item-field">备注</span>
          </Col>
          <Col span="12">
            <textarea-len v-model="remark" placeholder="最大100个字符，1个中文等于2个字符" :max="100" width="352" />
          </Col>
        </Row>
      </moduler>
    </div>
    <!-- 按钮 -->
    <div class="c-group-submit">
      <Row :gutter="12">
        <Col span="12">
          <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="errRes = []"></error-pop>
        </Col>
        <Col span="12" class="c-btns-submit">
          <Button @click.stop="cannel">取消</Button>
          <Button type="primary" v-if="editState" :loading="loading" @click.stop="submit(0)">
            <span v-if="!loading">更新</span>
            <span v-else>提交中...</span>
          </Button>
          <Button type="primary" v-else :loading="loading" @click.stop="submit(1)">
            <span v-if="!loading">提交</span>
            <span v-else>提交中...</span>
          </Button>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import { isArray, isEmpty, timeout, formatDate, pinyinUpCase } from '@/common/js/utils'
import ruleData from '../data/dmp_cond'
import validMixin from '../mixins/valid-mixin'

import Moduler from '@/components/moduler.vue'
import ErrorPop from '@/components/error-pop.vue'
import InputLen from '@/components/input/input-len.vue'
import Condition from '@/components/condition/condition'
import TextareaLen from '@/components/input/textarea-len.vue'

import { addDmpMangePackage, getDmpPackageById } from '@/api/manage.model'
import { getMiddleGameList, getSysMedia } from '@/api/common.model'

const disabledDate = (date) => {
  return (date && date.valueOf() < new Date(1577808000000)) || (date && date.valueOf() > Date.now()) // 2020-01-01 00:00:00
}
const now = formatDate(new Date(), 'yyyy-MM-dd')

export default {
  name: 'dmpAdd',
  mixins: [validMixin],
  components: { Moduler, ErrorPop, InputLen, Condition, TextareaLen },
  computed: {
    editState() {
      return this.$route.query.t === 'edit'
    },
    isAutoSwitch() {
      return this.$route.query.autoSwitch
    },
    title() {
      return this.editState ? '修改DMP包' : '创建DMP包'
    }
  },
  data() {
    return {
      id: this.$route.query && this.$route.query.id,
      loading: null,
      show: null,
      formErr: null,
      errRes: [],

      platform: 1,
      gameId: [],
      dmpType: 1,
      dataType: 'active',
      timeType: undefined,
      beginTime: formatDate(new Date('2020-01-01'), 'yyyy-MM-dd'),
      endTime: now,
      paySwitch: 0,
      payAction: [],
      mediaSwitch: 0,
      mediaIds: [],
      dmpName: '',
      dmpSimpleName: '',
      remark: '',

      disabledDate,
      ruleData,
      mediaData: [], // 媒体
      gameData: [] // 中间件游戏
    }
  },
  methods: {
    changePlatform(v) {
      if (v === 2) {
        this.dmpType = 3
      } else {
        this.dmpType = 1
      }
    },
    getData() {
      if (this.id) {
        getDmpPackageById({ id: this.id }).then((data) => {
          if (typeof data !== 'symbol') {
            const {
              platform,
              gameId,
              dmpType,
              dataType,
              timeType,
              beginTime,
              endTime,
              paySwitch,
              payAction,
              mediaSwitch,
              mediaIds,
              dmpName,
              dmpSimpleName,
              remark
            } = data
            this.platform = platform
            const transferGameId = typeof gameId === 'number' ? gameId + '' : gameId
            const gameIdsArr = transferGameId.includes(',') ? gameId.split(',') : [gameId]
            const newGameId = gameIdsArr.map(Number)
            this.gameId = newGameId
            this.dmpType = dmpType
            this.dataType = dataType
            this.timeType = timeType
            this.beginTime = beginTime
            this.endTime = this.isAutoSwitch ? now : endTime || now
            this.paySwitch = paySwitch
            this.mediaSwitch = Number(Boolean(mediaSwitch))
            this.mediaIds = mediaIds
            this.dmpName = dmpName
            this.dmpSimpleName = dmpSimpleName
            this.remark = remark
            paySwitch === 1 && (this.payAction = payAction)
            this.show = true
          }
        })
      }
    },
    changeSimpleName(val) {
      if (typeof val === 'string' && val) this.dmpSimpleName = pinyinUpCase(val)
      else this.dmpSimpleName = ''
    },
    changeDataType(val) {
      this.beginTime = val === 'lively' ? undefined : '2020-01-01'
      this.endTime = formatDate(new Date(), 'yyyy-MM-dd')
      this.timeType = val === 'lively' ? 1 : undefined
    },
    changeBeginTime(val) {
      this.beginTime = formatDate(new Date(val), 'yyyy-MM-dd')
    },
    changeEndTime(val) {
      this.endTime = formatDate(new Date(val), 'yyyy-MM-dd')
    },
    handleGame(meta) {
      // console.log(meta)
      // this.gameId = meta ? meta.id : ''
      this.gameId = meta
    },
    valid() {
      const rules = [
        {
          name: 'dmpName',
          require: true,
          min: 1,
          max: 25,
          desc: 'DMP包名称'
        },
        {
          name: 'dmpSimpleName',
          require: true,
          min: 1,
          max: 25,
          pattern: '^[^\u4E00-\u9FFF]+$',
          desc: 'DMP包简称',
          msg: 'DMP包简称不允许出现汉字'
        },
        {
          name: 'remark',
          max: 100,
          desc: '备注'
        },
        {
          name: 'gameId',
          require: true,
          desc: '中间件游戏'
        },
        {
          name: 'mediaIds',
          require: true,
          relyon: 'mediaSwitch',
          relyvalue: 1,
          min: 1,
          desc: '媒体'
        },
        {
          name: 'beginTime',
          require: true,
          relyon: 'dataType',
          relyvalue: 'active',
          desc: '自定义起始日期'
        },
        {
          name: 'beginTime',
          require: true,
          relyon: 'dataType',
          relyvalue: 'createRole',
          desc: '自定义起始日期'
        },
        {
          name: 'payAction',
          require: true,
          relyon: 'paySwitch',
          relyvalue: 1,
          min: 1,
          desc: '付费行为'
        }
      ]
      this.formErr = false
      return this.invalid(rules)
    },
    customValid() {
      const err = []

      if (this.paySwitch === 1) {
        const costEmpty = this.payAction
          .filter((ret) => ret.key === 'payCount')
          .some((ret) => (isArray(ret.value) ? ret.value.some((met) => isEmpty(met)) : isEmpty(ret.value)))
        const amountEmpty = this.payAction
          .filter((ret) => ret.key === 'payAmount')
          .some((ret) => (isArray(ret.value) ? ret.value.some((met) => isEmpty(met)) : isEmpty(ret.value)))

        const costValid = this.payAction
          .filter((ret) => ret.key === 'payCount')
          .some(
            (ret) =>
              (isArray(ret.value) ? Math.max(...ret.value) : Number(ret.value)) > 9999 ||
              (isArray(ret.value) ? Math.min(...ret.value) : Number(ret.value)) < 1
          )
        if (costEmpty) err.push({ feild: '付费行为', msg: '付费行为中付费次数的值不能为空！' })
        else if (costValid) err.push({ feild: '付费行为', msg: '付费行为中付费次数的取值，范围为：1 ~ 9999' })

        const amountValid = this.payAction
          .filter((ret) => ret.key === 'payAmount')
          .some(
            (ret) =>
              (isArray(ret.value) ? Math.max(...ret.value) : Number(ret.value)) > 999999999 ||
              (isArray(ret.value) ? Math.min(...ret.value) : Number(ret.value)) < 1
          )
        if (amountEmpty) err.push({ feild: '付费行为', msg: '付费行为中付费金额的值不能为空！' })
        else if (amountValid) err.push({ feild: '付费行为', msg: '付费行为中付费金额的取值，范围为：1 ~ 999999999' })
      }

      return err
    },
    submit(bool) {
      this.errRes = [...this.valid(), ...this.customValid()] // 表单验证
      if (this.errRes.length) {
        // 如果错误中断
        this.formErr = true
        return
      }

      const params = {
        platform: this.platform,
        gameId: this.gameId.join(','),
        dmpType: this.dmpType,
        dataType: this.dataType,
        beginTime: this.beginTime,
        timeType: this.timeType,
        paySwitch: this.paySwitch,
        mediaSwitch: this.mediaSwitch,
        mediaIds: this.mediaIds,
        dmpName: this.dmpName,
        dmpSimpleName: this.dmpSimpleName,
        remark: this.remark
      }
      if (!bool) Object.assign(params, { id: this.id })
      if (this.paySwitch === 1) {
        Object.assign(params, {
          payAction: this.payAction.map((ret) => {
            ret.value = isArray(ret.value) ? ret.value.join(',') : ret.value
            return ret
          })
        })
      }
      if (this.endTime !== formatDate(new Date(), 'yyyy-MM-dd')) Object.assign(params, { endTime: this.endTime })
      // console.log(params)
      this.$Spin.show()
      this.loading = true
      addDmpMangePackage(params).then((data) => {
        this.loading = false
        this.$Spin.hide()
        if (data) {
          const con = bool ? '提交' : '更新'
          this.$Message.success({
            closable: true,
            duration: 1.5,
            content: `${con}成功！2秒后自动跳转`
          })
          timeout(2000).then(() => {
            this.jump()
          })
        }
      })
    },
    jump() {
      this.$router.push({ name: 'dmplist' })
    },
    cannel() {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>关闭当前页面编辑信息将丢失，是否确定？</p>',
        onOk: () => {
          this.jump()
        }
      })
    },
    preloadData() {
      Promise.all([getMiddleGameList(), getSysMedia()]).then((data) => {
        const [gameData, mediaData] = data
        isArray(gameData) && (this.gameData = gameData)
        isArray(mediaData) && (this.mediaData = mediaData)
        if (this.editState) this.getData()
        else this.show = true
      })
    }
  },
  created() {
    this.preloadData()
  }
}
</script>
<style lang="scss" scoped>
.c-dmp {
  height: 100%;

  .module-content {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    height: calc(100% - 58px);
  }

  .c-group-submit {
    padding: 15px;
    min-width: 1130px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 #eff1fa;

    .c-btns-submit {
      text-align: right;

      .ivu-btn {
        margin-right: 0;
        margin-left: 20px;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
}

::v-deep .el-input input {
  padding: 0 8px;
}

::v-deep .el-select__input {
  margin-left: 8px;
}

::v-deep .el-select .el-tag {
  margin-left: 4px;
  display: flex;
  align-items: center;

  .el-select__tags-text {
    max-width: 94px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
</style>
